import { CompanyProfile } from './CompanyProfile'
import { CountryProfile } from './CountryProfile'
import { RiskProfile } from './RiskProfile'

export default { CompanyProfile, CountryProfile, RiskProfile }